import $ from 'jquery';


/* Offcanvas navigation
********************************************/

$('.js-main-menu-toggle').on('click', function (e) {
	e.preventDefault();
	// $('body').toggleClass('c-offcanvas--open');
	$('.c-body').toggleClass('c-body--freeze');
	$('.js-main-menu-toggle').toggleClass('is-active');
	$('.js-offcanvas').toggleClass('is-active');
});
// Close navigation when hit escape key
$('body').on("keydown", function (e) {
	if (e.keyCode == "27") {
		// $('body').removeClass('c-offcanvas--open');
		$('.c-body').removeClass('c-body--freeze');
		$('.js-main-menu-toggle').removeClass('is-active');
		$('.js-offcanvas').removeClass('is-active');
	}
});
// Close navigation when click outside
$(document).on('click', function (e) {
	if (!$(e.target).closest('.js-main-menu-toggle, .js-offcanvas, .js-main-search').length) {
		// $('body').removeClass('c-offcanvas--open');
		$('.c-body').removeClass('c-body--freeze');
		$('.js-main-menu-toggle').removeClass('is-active');
		$('.js-offcanvas').removeClass('is-active');
	}
});

if ($('.js-offcanvas-nav').length) {
	$('.js-offcanvas-nav .has-children').prepend('<span class="c-offcanvas-nav__toggle js-offcanvas-nav-toggle"></span>');

	$('.js-offcanvas-nav .js-offcanvas-nav-toggle').click(function(){
		$(this).siblings('ul').slideToggle();
		$(this).parent().toggleClass('is-active');
	});
}
